import { useContext } from 'react';
import JobsContext from 'src/contexts/JobsContext';

const useJobsContext = () => {
  const context = useContext(JobsContext);
  if (!context) {
    throw new Error('useJobsContext must be used within a JobsProvider');
  }
  return context;
};

export default useJobsContext;
